import axios from "axios";
import { ErrorMessage, Field, FieldArray, Formik, FormikConsumer, FormikProps, useFormik } from "formik";
import React, { Component, useEffect, useState } from 'react';
import internal from "stream";
import Swal from 'sweetalert2';
import * as Yup from 'yup';
import { API_URL_LARAVEL } from "../config/config";
import InputField from "./shared-component/Input/InputField";

type DomandaFields = {

    laurea: string,
    universita: string,
    votazione: string,
    datalaurea: string,
    ilmaster: string,

    mesiesperienza: string,
    numeroalbo: string,

    nome: string,
    cognome: string,
    professione: string,
    cf: string,
    sesso: string,
    nascita: string,
    nazionenascita: string,
    comunenascita: string,
    provincianascita: string,
    piva: string,
    comuneresidenza: string,
    indirizzoresidenza: string,
    civicoresidenza: string,
    email: string,
    pec: string,
    cellulare: string,
    indirizzodomicilio: string,
    nomealbo: string,
    nomerecapito: string,
    indirizzorecapito: string,
    cellularerecapito: string,
    pecrecapito: string,
    telefonorecapito: string,
    ceckb1: boolean,
    ceckb2: boolean,
    telefono: string,
    privacy: boolean,
    dichiara1: boolean,
    dichiara2: boolean,
    dichiara3: boolean,
    dichiara4: boolean,
    dichiara5: boolean,
    dichiara6: boolean,
    dichiara7: boolean,
    dichiara8: boolean,
    dichiara9: boolean,
    dichiara10: boolean,
    dichiara11: boolean,
    esperienza: boolean,
    albo: boolean,
    disciplina: boolean,
    crediti: boolean,
    comunealbo: string,
    allegati: [],
    autovalutazioneb1: [],
    autovalutazioneb2: []
}

const MAX_FILE_SIZE = 2000400; //100KB

const validFileExtensions = { image: ['jpg', 'pdf', 'tif', 'png', 'jpeg'] };

const yupSchema = Yup.object().shape({
    ilmaster: Yup.string().required('Obbligatorio'),
    mesiesperienza: Yup.string().required('Obbligatorio'),
    laurea: Yup.string().required('Obbligatorio'),
    universita: Yup.string().required('Obbligatorio'),
    votazione: Yup.string().required('Obbligatorio'),

    nome: Yup.string().required('Nome è richiesto').min(2, "inserire almeno 2 caratteri"),
    cognome: Yup.string().required('Obbligatorio').min(2, "inserire almeno 2 caratteri"),

    cf: Yup.string().required('Obbligatorio').matches(
        /^[A-Za-z]{6}[0-9LMNPQRSTUV]{2}[A-Za-z]{1}[0-9LMNPQRSTUV]{2}[A-Za-z]{1}[0-9LMNPQRSTUV]{3}[A-Za-z]{1}$/,
        "Codice fiscale non conforme"
    ),
    sesso: Yup.string().required('Obbligatorio'),
    professione: Yup.string().required('Obbligatorio'),
    nascita: Yup.date()
        .min(new Date('1900-01-01'), "To Date cannot be before From Date")
        .max(new Date(), "Data non può essere futua")
        .required("Richiesto"),

    nazionenascita: Yup.string().required('Obbligatorio'),
    comunenascita: Yup.string().required('Obbligatorio'),
    comuneresidenza: Yup.string().required('Obbligatorio'),
    ceckb1: Yup.boolean().isTrue('Campo obbligatorio se maggiore di zero compilare autovalutazione B1'),
    ceckb2: Yup.boolean().isTrue('Campo obbligatorio se maggiore di zero compilare autovalutazione B2'),
    nomerecapito: Yup.string().required('Obbligatorio'),
    indirizzorecapito: Yup.string().required('Obbligatorio'),
    cellularerecapito: Yup.string().required('Obbligatorio'),

    votolaurea: Yup.string().required('Obbligatorio'),

    votoA: Yup.string().required('Obbligatorio'),
    datalaurea: Yup.string().required('Obbligatorio'),
    mesicomplessiviB1: Yup.string().required('Obbligatorio'),
    mesicomplessiviB2: Yup.string().required('Obbligatorio'),
    ValutazioneB2: Yup.string().required('Obbligatorio'),
    ValutazioneB1: Yup.string().required('Obbligatorio'),
    piva: Yup.string(),
    provincianascita: Yup.string().required('Obbligatorio'),
    indirizzoresidenza: Yup.string().required('Obbligatorio'),
    civicoresidenza: Yup.string().required('Obbligatorio'),
    cellulare: Yup.string().required('Obbligatorio'),
    indirizzodomicilio: Yup.string(),
    telefono: Yup.string(),
    privacy: Yup.boolean().isTrue(),
    telefonorecapito: Yup.string().required('Obbligatorio'),
    emailrecapito: Yup.string().required('Obbligatorio'),
    pecrecapito: Yup.string().required('Obbligatorio'),
    telefonobeneficiario: Yup.string(),
    dichiara1: Yup.boolean().isTrue(),
    dichiara2: Yup.boolean().isTrue(),
    dichiara3: Yup.boolean().isTrue(),
    dichiara4: Yup.boolean().isTrue(),
    dichiara5: Yup.boolean().isTrue(),
    dichiara6: Yup.boolean().isTrue(),
    dichiara7: Yup.boolean().isTrue(),
    dichiara8: Yup.boolean().isTrue(),
    dichiara9: Yup.boolean().isTrue(),
    dichiara10: Yup.boolean().isTrue(),
    dichiara11: Yup.boolean().isTrue(),

    esperienza: Yup.boolean().isTrue(),
    albo: Yup.boolean(),
    disciplina: Yup.boolean().isTrue(),
    crediti: Yup.boolean().isTrue(),


    autovalutazioneb1: Yup.array().of(
        Yup.object().shape({
            denominazione: Yup.string(),
            descrizione: Yup.string(),
            datainizio: Yup.string(),
            datafine: Yup.string(),
            durata: Yup.string()
        })
    ),
    autovalutazioneb2: Yup.array().of(
        Yup.object().shape({
            denominazione: Yup.string(),
            descrizione: Yup.string(),
            datainizio: Yup.string(),
            datafine: Yup.string(),
            durata: Yup.string()
        })
    ),

    allegati: Yup.array().of(
        Yup.object().shape({

            documento: Yup
                .mixed()
                .required("Obbligatorio")
                .test("is-valid-size", "Dimensione Massima 2M",
                    value => value && value.size <= MAX_FILE_SIZE),
            curriculum: Yup
                .mixed()
                .required("Obbligatorio")
                .test("is-valid-size", "Dimensione Massima 2M",
                    value => value && value.size <= MAX_FILE_SIZE)


        })
    ),



})

const valoriIniziali: DomandaFields = {
    mesiesperienza: "22",
    numeroalbo: "",
    ceckb1: false,
    ceckb2: false,
    ilmaster: "dafdasf",
    laurea: "fdsaf",
    universita: "fsdaf",
    votazione: "fdsaf",
    datalaurea: "fdasf",
    professione: "dsafasd",
    comunealbo: "",
    nome: "test",
    cognome: "test",
    nomealbo: "",
    cf: "test",
    sesso: "test",
    nascita: "10/10/2020",
    nazionenascita: "10/10/2020",
    comunenascita: "test",
    provincianascita: "test",
    piva: "test",
    indirizzoresidenza: "test",
    comuneresidenza: "test",
    civicoresidenza: "test",
    email: "test",
    pec: "test",
    cellulare: "test",
    telefono: "test",
    indirizzodomicilio: "",
    privacy: true,
    dichiara1: true,
    dichiara2: true,
    dichiara3: true,
    dichiara4: true,
    dichiara5: true,
    dichiara6: true,
    dichiara7: true,
    dichiara8: true,
    dichiara9: true,
    dichiara10: true,
    dichiara11: true,
    esperienza: true,
    albo: true,
    disciplina: true,
    crediti: true,
    nomerecapito: 'test',
    indirizzorecapito: 'test',
    cellularerecapito: 'test',
    allegati: [],
    autovalutazioneb1: [],
    autovalutazioneb2: [],
    pecrecapito: "test",
    telefonorecapito: "",
    /* 
mesiesperienza: "",
 nomealbo: "",
  numeroalbo: "",
 comunealbo: "",
ilmaster: "",
laurea: "",
universita: "",
votazione: "",
datalaurea: "",
professione: "",
ceckb1: false,
ceckb2: false,
nome: "",
cognome: "",
cf: "",
sesso: "",
nascita: "",
nazionenascita: "",
comunenascita: "",
provincianascita: "",
piva: "",
indirizzoresidenza: "",
comuneresidenza: "",
civicoresidenza: "",
email: "",
pec: "",
cellulare: "",
telefono: "",
indirizzodomicilio: "",
privacy: false,
dichiara1: false,
dichiara2: false,
dichiara3: false,
dichiara4: false,
dichiara5: false,
dichiara6: false,
dichiara7: false,
dichiara8: false,
dichiara9: false,
dichiara10: false,
dichiara11: false,
esperienza: false,
albo: false,
disciplina: false,
crediti: false,


nomerecapito: '',
indirizzorecapito: '',
cellularerecapito: '',
allegati: [],
autovalutazioneb1: [],
autovalutazioneb2: [],
pecrecapito: "",
telefonorecapito: ""
//*/
}
const Toast = Swal.mixin({
    position: 'top-end',
    timer: 2000,
    showConfirmButton: false,
    toast: true,
})


const Domanda = () => {
    const [visual, setsetvisual] = useState(false)
    const [update, setupdate] = useState(false);
    // @ts-ignore 
    /*  valoriIniziali.allegati.push({
          documento: null,
          curriculum: null,
  
      });
      // */

    const stampa_id = (id: any) => {
        var nw = window.open();
        var html = document.body.innerHTML + '<style> .body{ width: 200px} </style>'

        nw.document.write(document.body.innerHTML);
        //   nw.print();
        //   nw.close();
    }

    const aggiungiValutazione = (e: any, formik: any) => {
        //   console.log('figli', formik.values.figli);
        formik.values.ceckb1 = true;

        formik.values.autovalutazioneb1.push({
            denominazione: '',
            descrizione: '',
            datainizio: '',
            datafine: '',
            durata: ''
        }
        );

        setupdate(!update);
    }

    const verificamesib1 = (e: any, formik: any) => {

        if (formik.values.ceckb1 == false && e == 0) {
            formik.values.ceckb1 = true;
        }

        console.log('mesicomplessiviB1', formik.values.mesicomplessiviB1);
        console.log('ceckb1', formik.values.ceckb1);
    }

    const verificamesib2 = (e: any, formik: any) => {

        if (formik.values.ceckb2 == false && e == 0) {
            formik.values.ceckb2 = true;
        }


        console.log('mesicomplessiviB2', formik.values.mesicomplessiviB2);
        console.log('ceckb2', formik.values.ceckb2);
    }
    const aggiungiValutazione2 = (e: any, formik: any) => {
        //   console.log('figli', formik.values.figli);

        formik.values.ceckb2 = true;
        formik.values.autovalutazioneb2.push({
            denominazione: '',
            descrizione: '',
            datainizio: '',
            datafine: '',
            durata: ''
        }
        );

        setupdate(!update);
    }

    return (
        <>

            <Formik initialValues={valoriIniziali}
                validationSchema={yupSchema}
                validateOnBlur={false}
                validateOnChange={false}
                onSubmit={(values) => {
                    const fileInput = document.querySelectorAll('input[type="file"]');
                    console.log(fileInput);
                    const data = JSON.stringify({ ...values })
                    const fd = new FormData();
                    // append directly as part of the postData in plain text
                    fd.append('istanzajson', data);
                    fd.append('identificativo', "1983458");
                    fd.append('nome', "Domanda LongList");
                    fileInput.forEach((docItem) => {
                        fd.append(docItem.id, (document.getElementById(docItem.id) as HTMLInputElement).files[0]);
                    });
                    axios.post(API_URL_LARAVEL + '/istanza', fd, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }
                    ).then((response) => {
                        //    console.log(response);
                        /*   if (response.data.success) {
                               Toast.fire({
                                   title: response.data.text,
                                   icon: 'success'
                               });
                               window.location.href = "/esito?id=" + response.data.result;
                           } //*/
                    }).catch((err) => {
                        // console.log(err);
                        alert('Errore imprevisto Allegati obbligatori. Provare a rinominare i file allegati senza utilizzare caratteri speciali');
                        document.getElementById('spinner').style.display = 'none';
                        document.getElementById('_conferma').style.display = 'inline';
                    });

                    //    alert(JSON.stringify(values));
                }}>
                {(formik: FormikProps<any>) => (
                    <div className="form">
                        <div className="form-group">
                            <div className="col-sm-12 col-sm-offset-1" >
                                <table>
                                    <tbody><tr>
                                        <td>
                                            <ol className="breadcrumb" style={{ backgroundColor: 'white' }}>

                                                <li className="active"> <strong>
                                                    AVVISO PUBBLICO PER LA COSTITUZIONE DI UNA LONG LIST DI ESPERTI PER IL CONFERIMENTO DI INCARICHI PROFESSIONALI ESTERNI PER L’IMPLEMENTAZIONE DI INTERVENTI DI SEGRETARIATO SOCIALE DEL SERVIZIO SOCIALE PROFESSIONALE DEI COMUNI AFFERENTI ALL’AMBITO TERRITORIALE SOCIALE N. 2 DI RENDE.

                                                </strong> </li>
                                            </ol>
                                        </td>
                                    </tr>
                                    </tbody></table>
                            </div>
                        </div>
                        <div id="div_domanda">
                            <br />
                            <div className="form-group">
                                <div className="col-sm-12 text-center white bg-primary" style={{ color: 'white' }}>Dati Anagrafici </div></div>
                            <div className="row">
                                <div className="col-sm">
                                    <Field component={InputField} id='nome' label='Nome' />
                                </div>
                                <div className="col-sm">
                                    <Field component={InputField} id='cognome' label='Cognome' />
                                </div>
                                <div className="col-sm">
                                    <div className="form-group">
                                        <label htmlFor='cf'>Codice Fiscale</label>
                                        <input type="text" className="form-control" name='cf' id='cf' onChange={event => formik.setFieldValue('cf', event.target.value)} />
                                        <small className="error">  <ErrorMessage name='cf' /> </small>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm">
                                    <div className="form-group">
                                        <div className="select-wrapper">
                                            <label htmlFor="sesso">Sesso</label>
                                            <select id="sesso" onChange={event => formik.setFieldValue('sesso', event.target.value)}>
                                                <option selected value="">Scegli un'opzione</option>
                                                <option value="M">M</option>
                                                <option value="F">F</option>
                                            </select>
                                            <small className="error">  <ErrorMessage name={`sesso`} /> </small>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm">
                                    <div className="form-group">
                                        <label className="active" htmlFor="nascita">Data di nascita (gg/mm/aaaa)</label>
                                        <input type="date" id="nascita" name="nascita" onChange={evt => {
                                            formik.setFieldValue('nascita', evt.target.value)
                                        }} />

                                        <small className="error">  <ErrorMessage name='nascita' /> </small>

                                    </div>
                                </div>
                                <div className="col-sm">
                                    <div className="select-wrapper">
                                        <label htmlFor="nazionenascita">Nazione di nascita</label>
                                        <select id="nazionenascita" onChange={event => formik.setFieldValue('nazionenascita', event.target.value)} >
                                            <option selected value="">Scegli un'opzione</option>
                                            <option value={122}>ITALIA</option><option value={1}>AFGHANISTAN</option><option value={2}>ALBANIA</option><option value={3}>ALGERIA</option><option value={4}>ANDORRA</option><option value={5}>ANGOLA</option><option value={6}>ANGUILLA</option><option value={7}>ANTIGUA E BARBUDA</option><option value={8}>ANTILLE BRITANNICHE</option><option value={9}>ANTILLE OLANDESI</option><option value={10}>ARABIA SAUDITA</option><option value={11}>ARGENTINA</option><option value={12}>ARMENIA</option><option value={13}>AUSTRALIA</option><option value={14}>AUSTRIA</option><option value={15}>AZERBAIGIAN</option><option value={16}>BAHAMA</option><option value={17}>BAHREIN</option>
                                            <option value={18}>BANGLADESH</option><option value={19}>BARBADOS</option><option value={20}>BELGIO</option><option value={21}>BELIZE</option><option value={22}>BENIN</option><option value={23}>BERMUDA (ISOLE)</option><option value={24}>BHUTAN</option><option value={25}>BIELORUSSIA</option><option value={26}>BIRMANIA</option><option value={27}>BOLIVIA</option><option value={28}>BOSNIA ED ERZEGOVINA</option><option value={29}>BOTSWANA</option><option value={30}>BRASILE</option><option value={31}>BRUNEI</option><option value={32}>BULGARIA</option><option value={33}>BURKINA FASO</option><option value={34}>BURUNDI</option><option value={35}>CAMBOGIA</option><option value={36}>CAMERUN</option><option value={37}>CANADA</option><option value={38}>CAPO VERDE</option><option value={39}>CAYMAN (ISOLE)</option><option value={40}>CECOSLOVACCHIA</option><option value={41}>CENTRAFRICANA REPUBBLICA</option><option value={42}>CHRISTMAS (ISOLA)</option><option value={43}>CIAD</option><option value={44}>CILE</option><option value={45}>CINA (REPUBBLICA POPOLARE)</option><option value={46}>CIPRO</option><option value={47}>CITTA' DEL VATICANO</option><option value={48}>ISOLE COCOS (KEELING)</option><option value={49}>COLOMBIA</option><option value={50}>COMORE</option>
                                            <option value={51}>CONGO REBUBBLICA DEMOCRATICA (ZAIRE)</option><option value={52}>CONGO REPUBBLICA POPOLARE</option><option value={53}>COOK</option><option value={54}>COREA DEL NORD, REPUBBLICA DEMOCRATICA</option><option value={55}>COREA DEL SUD, REPUBBLICA DI COREA</option><option value={56}>COSTA D'AVORIO</option><option value={57}>COSTA RICA</option><option value={58}>CROAZIA</option><option value={59}>CUBA</option><option value={60}>DANIMARCA</option><option value={61}>DIPENDENZE AUSTRALIANE</option><option value={62}>DIPENDENZE BRITANNICHE</option><option value={63}>DIPENDENZE CANADESI</option><option value={64}>DIPENDENZE FRANCESI</option><option value={65}>DIPENDENZE NEOZELANDESI</option><option value={66}>DIPENDENZE NORVEGESI ANTARTICHE</option><option value={67}>DIPENDENZE NORVEGESI ARTICHE</option><option value={68}>DIPENDENZE RUSSE</option><option value={69}>DIPENDENZE STATUNITENSI</option><option value={70}>DIPENDENZE SUDAFRICANE</option><option value={71}>DOMINICA</option><option value={72}>ECUADOR</option><option value={73}>EGITTO</option><option value={74}>EL SALVADOR</option><option value={75}>EMIRATI ARABI UNITI</option><option value={76}>ERITREA</option><option value={77}>ESTONIA</option><option value={78}>ETIOPIA</option><option value={79}>FAER OER (Isole)</option><option value={80}>FIGI O VITI</option><option value={81}>FILIPPINE</option><option value={82}>FINLANDIA</option><option value={83}>FRANCIA</option><option value={84}>GABON</option><option value={85}>GAMBIA</option><option value={86}>TERRITORI PALESTINESI (GAZA)</option><option value={87}>GEORGIA</option><option value={88}>GERMANIA</option><option value={89}>GERMANIA REPUBBLICA DEMOCRATICA</option><option value={90}>GERMANIA REPUBBLICA FEDERALE</option><option value={91}>GHANA</option><option value={92}>GIAMAICA</option>
                                            <option value={93}>GIAPPONE</option><option value={94}>GIBILTERRA</option><option value={95}>GIBUTI</option><option value={96}>GIORDANIA</option><option value={97}>GRAN BRETAGNA E IRLANDA DEL NORD</option><option value={98}>GRECIA</option><option value={99}>GRENADA</option><option value={100}>GROENLANDIA</option><option value={101}>GUADALUPA</option><option value={102}>GUAM (ISOLA)</option><option value={103}>GUATEMALA</option><option value={104}>GUIANA FRANCESE</option><option value={105}>GUINEA</option><option value={106}>GUINEA BISSAU</option><option value={107}>GUINEA EQUATORIALE</option><option value={108}>GUYANA</option><option value={109}>HAITI</option><option value={110}>HONDURAS</option><option value={111}>HONG KONG</option><option value={112}>INDIA</option><option value={113}>INDONESIA</option><option value={114}>IRAN</option><option value={115}>IRAQ</option><option value={116}>IRIAN OCCIDENTALE</option><option value={117}>IRLANDA (Eire)</option><option value={118}>ISLANDA</option>
                                            <option value={119}>ISOLE CILENE (PASQUA E SALA Y GOMEZ)</option><option value={120}>ISOLE VERGINI BRITANNICHE</option><option value={121}>ISRAELE</option><option value={123}>JUGOSLAVIA</option><option value={124}>KAZAKISTAN</option><option value={125}>KENYA</option><option value={126}>KIRGHIZISTAN</option><option value={127}>KIRIBATI</option><option value={128}>KUWAIT</option><option value={129}>LA REUNION (ISOLA)</option><option value={130}>LAOS</option><option value={131}>LESOTHO</option><option value={132}>LETTONIA</option><option value={133}>LIBANO</option><option value={134}>LIBERIA</option><option value={135}>LIBIA</option><option value={136}>LIECHTENSTEIN</option><option value={137}>LITUANIA</option><option value={138}>LUSSEMBURGO</option><option value={139}>MACAO</option><option value={140}>MACEDONIA</option><option value={141}>MACQUARIE (ISOLE)</option><option value={142}>MADAGASCAR</option><option value={143}>MALAWI</option>
                                            <option value={144}>MALAYSIA</option><option value={145}>MALDIVE</option><option value={146}>MALI</option><option value={147}>MALTA</option><option value={148}>MALVINE O FALKLAND (ISOLE)</option><option value={149}>MAN (ISOLA)</option><option value={150}>MARIANNE (ISOLE)</option><option value={151}>MAROCCO</option><option value={152}>MARSHALL</option><option value={153}>MARTINICA</option><option value={154}>MAURITANIA</option><option value={155}>MAURIZIO</option><option value={156}>MAYOTTE (ISOLA)</option><option value={157}>MESSICO</option><option value={158}>MICRONESIA STATI FEDERATI</option><option value={159}>MIDWAY</option><option value={160}>MOLDAVIA</option><option value={161}>MONACO</option><option value={162}>MONGOLIA</option><option value={163}>MONTSERRAT</option><option value={164}>MOZAMBICO</option><option value={165}>NAMIBIA</option><option value={166}>NAURU</option><option value={167}>NEPAL</option><option value={168}>NICARAGUA</option><option value={169}>NIGER</option><option value={170}>NIGERIA</option><option value={171}>NIUE O SAVAGE (ISOLE)</option><option value={172}>NORFOLK (ISOLE DEL MAR DEI CORALLI)</option><option value={173}>NORMANNE (ISOLE)</option><option value={174}>NORVEGIA</option><option value={175}>NUOVA CALEDONIA (ISOLE E DIPENDENZE)</option><option value={176}>NUOVA ZELANDA</option><option value={177}>OMAN</option><option value={178}>PAESI BASSI (OLANDA)</option>
                                            <option value={179}>PAKISTAN</option><option value={180}>PALAU</option><option value={181}>PANAMA</option><option value={182}>PANAMA ZONA DEL CANALE</option><option value={183}>PAPUA NUOVA GUINEA</option><option value={184}>PARAGUAY</option><option value={185}>PERU'</option><option value={186}>PITCAIRN (E DIPENDENZE)</option><option value={187}>POLINESIA FRANCESE (ISOLE)</option><option value={188}>POLONIA</option><option value={189}>PORTOGALLO</option><option value={190}>PUERTO RICO</option><option value={191}>QATAR</option><option value={192}>REPUBBLICA CECA</option><option value={193}>REPUBBLICA DELLA GUAYANA</option><option value={194}>REPUBBLICA DOMINICANA</option><option value={195}>ROMANIA</option><option value={196}>RUANDA</option><option value={197}>RUSSIA (FEDERAZIONE RUSSA)</option><option value={198}>SAINT KITTS E NEVIS</option><option value={199}>SANTA LUCIA</option><option value={200}>SAINT PIERRE ET MIQUELON</option><option value={201}>SAINT VINCENT E GRENADINE</option><option value={202}>SALOMONE</option><option value={203}>SAMOA</option><option value={204}>SAMOA AMERICANE (ISOLE)</option><option value={205}>SAN MARINO</option><option value={206}>SANT'ELENA (ISOLA)</option><option value={207}>SAO TOME' E PRINCIPE</option><option value={208}>SEICELLE</option><option value={209}>SENEGAL</option><option value={210}>SIERRA LEONE</option><option value={211}>SINGAPORE</option><option value={212}>SIRIA</option><option value={213}>SLOVACCHIA (REPUBBLICA)</option><option value={214}>SLOVENIA</option><option value={215}>SOMALIA</option><option value={216}>SPAGNA</option><option value={217}>SRI LANKA</option><option value={218}>STATI UNITI D'AMERICA</option><option value={219}>STRANIERO</option><option value={220}>SUDAFRICANA REBUBBLICA</option><option value={221}>SUDAN</option><option value={222}>SURINAME</option><option value={223}>SVEZIA</option><option value={224}>SVIZZERA</option><option value={225}>SWAZILAND</option><option value={226}>TAGIKISTAN</option><option value={227}>TAIWAN (FORMOSA)</option><option value={228}>TANZANIA</option><option value={229}>THAILANDIA</option><option value={230}>TIMOR (ISOLA)</option><option value={231}>TOGO</option><option value={232}>TOKELAU (ISOLE DELL'UNIONE)</option><option value={233}>TONGA (ISOLE DEGLI AMICI)</option><option value={234}>TRINIDAD E TOBAGO</option>
                                            <option value={235}>TUNISIA</option><option value={236}>TURCHIA</option><option value={237}>TURKEMENISTAN</option><option value={238}>TURKS E CAICOS (ISOLE)</option><option value={239}>TUVALU</option><option value={240}>UCRAINA</option><option value={241}>UGANDA</option><option value={242}>UNGHERIA</option><option value={243}>URUGUAY</option><option value={244}>UZBEKISTAN</option><option value={245}>VANUATU</option><option value={246}>VENEZUELA</option>
                                            <option value={247}>ISOLE VERGINI AMERICANE</option><option value={248}>VIETNAM</option><option value={249}>VOLTA (ALTOVOLTA)</option><option value={250}>WALLIS E FUTUNA (ISOLE)</option><option value={251}>YEMEN</option><option value={252}>ZAMBIA</option><option value={253}>ZIMBABWE</option><option value={254}>Kosovo</option><option value={255}>SERBIA E MONTENEGRO</option><option value={256}>URSS - Unione Repubbliche Socialiste Sovietiche</option><option value={257}>SIERRA LEONE</option><option value={258}>APOLIDE</option><option value={259}>MONTENEGRO</option><option value={260}>TOGO</option><option value={261}>TERRITORI PALESTINESI</option><option value={263}>SERBIA</option>
                                        </select>
                                        <small className="error">  <ErrorMessage name={`nazionenascita`} /> </small>
                                    </div>
                                </div>
                            </div>


                            <div className="row">
                                <div className="col-sm">
                                    <Field component={InputField} id='comunenascita' label='Comune di nascita' />
                                </div>
                                <div className="col-sm">

                                    <Field component={InputField} id='provincianascita' label='provincianascita' />

                                </div>
                                <div className="col-sm">
                                    <Field component={InputField} id='piva' label='Partita iva se già in possesso ' />
                                </div>
                            </div>

                            <br />

                            <div className="form-group"><div className="col-sm-12 text-center white bg-primary" style={{ color: 'white' }}>Dati Residenza / Domicilio</div></div>
                            <div className="row">
                                <div className="col-sm">
                                    <Field component={InputField} id='comuneresidenza' label='comuneresidenza' />
                                </div>
                                <div className="col-sm">
                                    <Field component={InputField} id='indirizzoresidenza' label='Indirizzo' />
                                </div>
                                <div className="col-sm">
                                    <Field component={InputField} id='civicoresidenza' label='Civico di residenza' />
                                </div>
                                <div className="col-sm">
                                    <Field component={InputField} id='telefonobeneficiario' label='Telefono ' />
                                </div>
                            </div>

                            <div className="row">

                                <div className="col-sm">
                                    <Field component={InputField} id='indirizzodomicilio' label='Domicilio (se diverso dalla residenza)' />
                                </div>
                            </div>

                            <br />

                            <div className="form-group"><div className="col-sm-12 text-center white bg-primary" style={{ color: 'white' }}>recapito</div>
                            </div>

                            <div className="row">
                                <div className="col-sm">
                                    <div className="form-group">
                                        <label htmlFor='email'>e-mail</label>
                                        <input type="text" className="form-control" name='email' id='email' onChange={event => formik.setFieldValue('email', event.target.value)} />
                                        <small className="error">  <ErrorMessage name='email' /> </small>
                                    </div>
                                </div>
                                <div className="col-sm">
                                    <div className="form-group">
                                        <label htmlFor='pec'>PEC</label>
                                        <input type="text" className="form-control" name='pec' id='pec' onChange={event => formik.setFieldValue('pec', event.target.value)} />
                                        <small className="error">  <ErrorMessage name='pec' /> </small>
                                    </div>
                                </div>
                                <div className="col-sm">
                                    <Field component={InputField} id='telefono' label='telefono' />
                                </div>
                                <div className="col-sm">
                                    <Field component={InputField} id='cellulare' label='Cellulare' />
                                </div>
                            </div>


                            <br />
                            <div className="form-group"><div className="col-sm-12 text-center white bg-primary" style={{ color: 'white' }}>CHIEDE</div></div>


                            <p>
                                di essere ammesso a partecipare all’avviso pubblico per la costituzione di una long list di esperti per il conferimento di incarichi professionali esterni per l’implementazione di interventi in favore dei nuclei familiari in carico al servizio sociale professionale dei comuni afferenti all’Ambito Territoriale Sociale del distretto di Rende, ivi inclusa la figura dell’esperto per il supporto amministrativo (indicare solo la figura professionale per la quale intende candidarsi):

                            </p>
                            <br />

                            <select name='professione' onChange={event => {
                                formik.setFieldValue('professione', event.target.value);
                                if (event.target.value == 'mediatoreculturale')
                                    setsetvisual(true);
                                else
                                    setsetvisual(false);

                            }
                            }>
                                <option value=''>Seleziona ...</option>
                                <option value='assistentesociale'> ASSISTENTE SOCIALE</option>
                                <option value='psicologo'>PSICOLOGO</option>
                                <option value='educatoreprofesionale'>EDUCATORE PROFESSIONALE</option>
                                <option value='mediatoreculturale'>MEDIATORE CULTURALE</option>
                                <option value='supportoamministrativo'>ESPERTO PER SUPPORTO AMMINISTRATIVO</option>
                                <option value='rendicontazione'>ESPERTO IN RENDICONTAZIONE</option>
                                <option value='dinamichesociali'> OPERATORE SPECIALIZZATO IN DINAMICHE SOCIALI</option>

                            </select>
                            <small className="error">  <ErrorMessage name={`professione`} /> </small> <br />

                            <br />
                            <div className="form-group"><div className="col-sm-12 text-center white bg-primary" style={{ color: 'white' }}>Dichiara</div></div>
                            <strong>
                                sotto la propria responsabilità, consapevole di quanto prescritto dall’art. 76 del DPR 28 dicembre 2000 n° 445 sulla responsabilità penale cui può andare incontro in caso di dichiarazioni mendaci:

                            </strong>

                            <div className="form-check">
                                <input id="dichiara1" type="checkbox" onChange={event => formik.setFieldValue('dichiara1', event.target.checked)} />
                                <label htmlFor="dichiara1" >
                                    Il godimento dei diritti politici e civili;
                                </label>
                                {formik.errors.dichiara1 && <small className="error">*Obbligatorio</small>}
                            </div>

                            <div className="form-check">
                                <input id="dichiara2" type="checkbox" onChange={event => formik.setFieldValue('dichiara2', event.target.checked)} />
                                <label htmlFor="dichiara2" >
                                    La cittadinanza italiana, salvo le equiparazioni stabilite dalle leggi vigenti, o cittadinanza di uno dei paesi dell’Unione europea;

                                </label>
                                {formik.errors.dichiara2 && <small className="error">*Obbligatorio</small>}
                            </div>

                            <div className="form-check">
                                <input id="dichiara3" type="checkbox" onChange={event => formik.setFieldValue('dichiara3', event.target.checked)} />
                                <label htmlFor="dichiara3" >
                                    L’assenza di condizioni che limitino o escludano, a norma di legge, la capacità di contrattare con la Pubblica Amministrazione;

                                </label>
                                {formik.errors.dichiara3 && <small className="error">*Obbligatorio</small>}
                            </div>

                            <div className="form-check">
                                <input id="dichiara4" type="checkbox" onChange={event => formik.setFieldValue('dichiara4', event.target.checked)} />
                                <label htmlFor="dichiara4" >
                                    L’inesistenza cause di incompatibilità e/o inconferibilità nonché conflitto con l’ente o con i comuni del Distretto per lo svolgimento dell’incarico;

                                </label>
                                {formik.errors.dichiara4 && <small className="error">*Obbligatorio</small>}
                            </div>


                            <div className="form-check">
                                <input id="dichiara5" type="checkbox" onChange={event => formik.setFieldValue('dichiara5', event.target.checked)} />
                                <label htmlFor="dichiara5" >
                                    Il possesso di titolo di studio richiesto dall’avviso pubblico, ed in dettaglio di possedere il seguente titolo di studio richiesto dall’avviso:

                                </label>
                                {formik.errors.dichiara5 && <small className="error">*Obbligatorio</small>}

                                <div className="row"></div>
                                <div style={{ marginTop: 10 }} className="row">

                                    <div className="col-sm">
                                        <div style={{ maxWidth: 300 }} className="form-group">
                                            <label htmlFor='laurea'>Laurea in</label>
                                            <input type="text" className="form-control" name='laurea' id='laurea' onChange={event => formik.setFieldValue('laurea', event.target.value)} />
                                            <small className="error">  <ErrorMessage name='laurea' /> </small>
                                        </div>
                                    </div>

                                    <div className="col-sm">
                                        <div style={{ maxWidth: 300 }} className="form-group">
                                            <label htmlFor='universita'>conseguita presso l’università</label>
                                            <input type="text" className="form-control" name='universita' id='universita' onChange={event => formik.setFieldValue('universita', event.target.value)} />
                                            <small className="error">  <ErrorMessage name='universita' /> </small>
                                        </div>
                                    </div>

                                    <div className="col-sm">
                                        <div style={{ maxWidth: 300 }} className="form-group">
                                            <label htmlFor='votazione'>con votazione</label>
                                            <input type="text" className="form-control" name='votazione' id='votazione' onChange={event => formik.setFieldValue('votazione', event.target.value)} />
                                            <small className="error">  <ErrorMessage name='votazione' /> </small>
                                        </div>
                                    </div>

                                </div>
                                <div className="row">
                                    <div className="col-sm">
                                        <label className="active" > Conseguita il  </label>
                                    </div>
                                    <div className="col-sm">

                                        <div className="form-group">

                                            <input type="date" id="datalaurea" name="datalaurea" onChange={evt => {
                                                formik.setFieldValue('datalaurea', evt.target.value)
                                            }} />

                                            <small className="error">  <ErrorMessage name='datalaurea' /> </small>
                                        </div>
                                    </div>
                                    <div className="col-sm"></div>
                                    <div className="col-sm"></div>
                                    <div className="col-sm"></div>
                                </div>


                                <div className="row">
                                    <p>Il possesso di esperienza documentata ed in dettaglio: </p>
                                </div>
                                <div className="row">
                                    <div className="form-check">
                                        <input id="esperienza" type="checkbox" onChange={event => formik.setFieldValue('esperienza', event.target.checked)} />
                                        <label htmlFor="esperienza" >
                                            <p style={{ float: 'left' }}> di avere maturato n°    </p>
                                            <input style={{ maxWidth: 100, float: 'left' }} type="number" className="form-control" name='mesiesperienza' id='mesiesperienza' onChange={event => formik.setFieldValue('mesiesperienza', event.target.value)} />
                                            {formik.errors.mesiesperienza && <small style={{ maxWidth: 100, float: 'left' }} className="error">*Obbligatorio</small>}

                                            <p style={{ float: 'left' }}>  mesi di esperienza professionale come specificato nella scheda di autovalutazione;
                                            </p>
                                        </label>
                                        {formik.errors.esperienza && <small className="error">*Obbligatorio</small>}
                                    </div>

                                    <div className="form-check">
                                        <input id="albo" type="checkbox" onChange={event => formik.setFieldValue('albo', event.target.checked)} />
                                        <label htmlFor="albo" >
                                            <p style={{ float: 'left' }}> di essere iscritto all’Albo professionale di riferimento ed in dettaglio all’albo     </p> <input style={{ maxWidth: 100, float: 'left' }} type="text" className="form-control" name='nomealbo' id='nomealbo' onChange={event => formik.setFieldValue('nomealbo', event.target.value)} />
                                            <p style={{ float: 'left' }}>  del    comune di </p> <input style={{ maxWidth: 200, float: 'left' }} type="text" className="form-control" name='comunealbo' id='comunealbo' onChange={event => formik.setFieldValue('comunealbo', event.target.value)} />
                                            <p style={{ float: 'left' }}>  al n° </p> <input style={{ maxWidth: 100, float: 'left' }} type="text" className="form-control" name='numeroalbo' id='numeroalbo' onChange={event => formik.setFieldValue('numeroalbo', event.target.value)} />

                                        </label>
                                        {formik.errors.albo && <small className="error">*Obbligatorio</small>}
                                    </div>

                                    <div style={{ width: '100%' }} className="form-check">
                                        <input id="disciplina" type="checkbox" onChange={event => formik.setFieldValue('disciplina', event.target.checked)} />
                                        <label htmlFor="disciplina" >
                                            assenza di provvedimenti sanzionatori di natura disciplinare;
                                        </label>
                                        {formik.errors.disciplina && <small className="error">*Obbligatorio</small>}
                                    </div>
                                    <div className="form-check">
                                        <input id="crediti" type="checkbox" onChange={event => formik.setFieldValue('crediti', event.target.checked)} />
                                        <label htmlFor="crediti" >
                                            essere in regola con l'obbligo dei crediti formativi professionali e regolarità contributiva.

                                        </label>
                                        {formik.errors.crediti && <small className="error">*Obbligatorio</small>}
                                    </div>
                                </div>

                                {visual && <> <div className="row">
                                    <p><strong>Limitatamente alla figura del Mediatore: </strong></p>
                                </div>
                                    <div className="row">
                                        <div className="form-check">
                                            <input id="ceckmediatore" type="checkbox" onChange={event => formik.setFieldValue('ceckmediatore', event.target.checked)} />
                                            <label htmlFor="ceckmediatore" >
                                                <p style={{ float: 'left' }}> La Qualifica professionale di mediatore interculturale acquisita mediante corsi di formazione professionale riconosciuti dalle Regioni o dai Ministeri     </p> <input style={{ maxWidth: 100, float: 'left' }} type="text" className="form-control" name='qualificamediatore' id='qualificamediatore' onChange={event => formik.setFieldValue('qualificamediatore', event.target.value)} />

                                                <br />   </label>
                                            {formik.errors.esperienza && <small className="error">*Obbligatorio</small>}
                                        </div>


                                        <div style={{ width: '100%' }} className="form-check">
                                            <input id="c1" type="checkbox" onChange={event => formik.setFieldValue('c1', event.target.checked)} />
                                            <label htmlFor="c1" >
                                                La Conoscenza lingua inglese LIVELLO C1;
                                            </label>
                                            {formik.errors.c1 && <small className="error">*Obbligatorio</small>}
                                        </div>
                                    </div>
                                </>}
                            </div>


                            <div className="form-group"><div className="col-sm-12 text-center white bg-primary" style={{ color: 'white' }}>DICHIARA INFINE CHE</div></div>

                            <div className="row">
                                <p>i recapito per eventuali comunicazioni successive alla presentazione della presente domanda di partecipazione sono:</p>


                                <div className="row">
                                    <div className="col-sm">
                                        <Field component={InputField} id='nomerecapito' label='Nome destinatario' />
                                    </div>

                                    <div className="col-sm">
                                        <Field component={InputField} id='indirizzorecapito' label='Indirizzo' />
                                    </div>
                                    <div className="col-sm">
                                        <Field component={InputField} id='telefonorecapito' label='Tel' />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm">
                                        <Field component={InputField} id='cellularerecapito' label='Cell' />
                                    </div>
                                    <div className="col-sm">
                                        <Field component={InputField} id='emailrecapito' label='E-mail' />
                                    </div>
                                    <div className="col-sm">
                                        <Field component={InputField} id='pecrecapito' label='PEC' />
                                    </div>
                                </div>

                                <br />
                                <div className="form-check">
                                    <input id="dichiara6" type="checkbox" onChange={event => formik.setFieldValue('dichiara6', event.target.checked)} />
                                    <label htmlFor="dichiara6" >
                                        Di avere preso visione integrale dell’Avviso Pubblico e di accettare tutte le norme in esso contenute;
                                    </label>
                                    {formik.errors.dichiara6 && <small className="error">*Obbligatorio</small>}
                                </div>
                                <div className="form-check">
                                    <input id="dichiara7" type="checkbox" onChange={event => formik.setFieldValue('dichiara7', event.target.checked)} />
                                    <label htmlFor="dichiara7" >
                                        Di essere a conoscenza che tutte le informazioni saranno pubblicate all’Albo Pretorio dei comuni dell’Ambito Territoriale Sociale di Rende;
                                    </label>
                                    {formik.errors.dichiara7 && <small className="error">*Obbligatorio</small>}
                                </div>

                                <div className="form-check">
                                    <input id="dichiara8" type="checkbox" onChange={event => formik.setFieldValue('dichiara8', event.target.checked)} />
                                    <label htmlFor="dichiara8" >
                                        Di essere consapevole che le modalità di perfezionamento dell’incarico, saranno comunicate dall’Ente a mezzo PEC, con valore di comunicazione e di notifica a tutti gli effetti di legge;
                                    </label>
                                    {formik.errors.dichiara8 && <small className="error">*Obbligatorio</small>}
                                </div>


                                <div className="form-check">
                                    <input id="dichiara9" type="checkbox" onChange={event => formik.setFieldValue('dichiara9', event.target.checked)} />
                                    <label htmlFor="dichiara9" >
                                        Di essere consapevole che potrà essere contattato per eventuali incarichi solo se risulta in possesso dei requisiti richiesti per l’accesso alla Long List;
                                    </label>
                                    {formik.errors.dichiara9 && <small className="error">*Obbligatorio</small>}
                                </div>



                                <div className="form-check">
                                    <input id="dichiara10" type="checkbox" onChange={event => formik.setFieldValue('dichiara10', event.target.checked)} />
                                    <label htmlFor="dichiara10" >
                                        Il sottoscritto si impegna inoltre a fornire tutta la documentazione dimostrante quanto dichiarato su richiesta dell’amministrazione che ha prodotto il presente avviso.
                                        Si autorizza l’Ente al trattamento dei propri dati personali per le finalità inerenti allo svolgimento della presente procedura.
                                    </label>
                                    {formik.errors.dichiara10 && <small className="error">*Obbligatorio</small>}
                                </div>


                            </div>

                            <br />
                            <div className="form-group"><div className="col-sm-12 text-center white bg-primary" style={{ color: 'white' }}>SCHEDA DI VALUTAZIONE</div></div>

                            <div className="row">
                                <img style={{ margin: '0 auto' }} className='titoli' src='/titoli.png'></img>
                            </div>

                            <div className="row">
                                <div style={{ width: '100%' }} className="form-group">
                                    <div className="select-wrapper">
                                        <label htmlFor="master">Valutazione Master I Livello – Master
                                            II Livello – Dottorato- ( *Solo per la
                                            figura psicologo diploma di Scuola di
                                            Specializzazione di Area Psicologica)</label>
                                        <select id="ilmaster" onChange={event => formik.setFieldValue('ilmaster', event.target.value)}>
                                            <option selected value="">Scegli un'opzione</option>
                                            <option value="NoMaster">Nessun titolo post laurea degli ammessi</option>
                                            <option value="Master Primo Livello">Master Universitario di Primo Livello</option>
                                            <option value="Master Secondo Livello">Master Universitario di Secondo Livello</option>
                                            <option value="Dottorato">Dottorato di Ricerca</option>
                                            <option value="diploma Psicologia">diploma di Scuola di Specializzazione di Area Psicologica</option>
                                        </select>
                                        <small className="error">  <ErrorMessage name={`ilmaster`} /> </small>
                                    </div>
                                </div>
                            </div>


                            <div className="row">
                                <div className="col-sm">
                                    <Field component={InputField} id='votolaurea' label='Votazione di laurea conseguita' />
                                </div>
                                <div className="col-sm">

                                    <div style={{ width: '100%' }} className="row">
                                        <Field style={{ width: '100%' }} component={InputField} id='votoA' label='Autovalutazione complessiva sez. A' />

                                    </div> </div>

                            </div>


                            <div className="row">
                                <img style={{ margin: '0 auto' }} className='b' src='/sezioneb.png'></img>
                            </div>
                            <br />
                            <div className="row">

                                <FieldArray
                                    name="valutazione"
                                    render={arrayHelpers => {
                                        const autovalutazioneb1 = formik.values.autovalutazioneb1;
                                        function handleFormChange(index: React.Key, event: React.ChangeEvent<HTMLInputElement>): void {

                                            formik.values.autovalutazioneb1[index+''][event.target.name.split('.')[2]] = event.target.value;
                                            console.log('value ', event.target.value, event.target.name.split('.')[2])

                                        }

                                        return (
                                            <div style={{ width: '100%' }}>
                                                {autovalutazioneb1 && autovalutazioneb1.length > 0
                                                    ? autovalutazioneb1.map((autoval: any, index: React.Key) => (
                                                        <div key={index}>

                                                            <div style={{ border: 'solid', padding: 30 }} key={index}>
                                                                <div className="row"><label>Valutazione {parseInt('' + index) + 1}</label>

                                                                    <div className="col-sm">
                                                                        <div className="form-group">

                                                                            <label htmlFor={`autovalutazioneb1.${index}.denominazione`}>Denominazione Ente /soggetto Committente</label>
                                                                            <input type="text" className="form-control" name={`autovalutazioneb1.${index}.denominazione`} id={`autovalutazioneb1.${index}.denominazione`} onChange={event => handleFormChange(index, event)} />
                                                                            <small className="error">    <ErrorMessage name={`autovalutazioneb1.${index}.denominazione`} /> </small>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-sm">
                                                                        <div className="form-group">
                                                                            <label htmlFor={`autovalutazioneb1.${index}.durata`}>Durata in Mesi</label>
                                                                            <input type="number" className="form-control" name={`autovalutazioneb1.${index}.durata`} id={`autovalutazioneb1.${index}.durata`} onChange={event => handleFormChange(index, event)} />
                                                                            <small className="error">  <ErrorMessage name={`autovalutazioneb1.${index}.durata`} /> </small>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="row">

                                                                    <div className="col-sm">

                                                                        <label >Data inizio incarico</label>

                                                                        <input type="date" id={`autovalutazioneb1.${index}.datainizio`} name={`autovalutazioneb1.${index}.datainizio`} onChange={event => handleFormChange(index, event)} />

                                                                        <small className="error">  <ErrorMessage name={`autovalutazioneb1.${index}.datainizio`} /> </small>



                                                                    </div>


                                                                    <div className="col-sm">

                                                                        <label >Data Fine incarico</label>

                                                                        <input type="date" id={`autovalutazioneb1.${index}.datafine`} name={`autovalutazioneb1.${index}.datafine`} onChange={event => handleFormChange(index, event)} />

                                                                        <small className="error">  <ErrorMessage name={`autovalutazioneb1.${index}.datafine`} /> </small>


                                                                    </div>
                                                                </div>




                                                            </div>

                                                        </div>


                                                    ))
                                                    : null}
                                                {
                                                    <button
                                                        type="button"
                                                        onClick={() => aggiungiValutazione(null, formik)} // insert an empty string at a position
                                                    >Aggiungi autovalutazione B1
                                                    </button>
                                                }
                                            </div>
                                        );
                                    }}
                                />

                                <div className="row"></div>
                                <div style={{ marginTop: 20, width: '100%' }} className="row">
                                    <br />

                                    <div className="col-sm">
                                        <div className="form-group">
                                            <label htmlFor='mesicomplessiviB1'>Durata in Mesi</label>
                                            <input type="number" className="form-control" name='mesicomplessiviB1' id='mesicomplessiviB1' onChange={

                                                event => {
                                                    formik.setFieldValue('mesicomplessiviB1', event.target.value)
                                                    verificamesib1(event.target.value, formik);

                                                }} />
                                            <small className="error">  <ErrorMessage name='ceckb1' /> </small>
                                        </div>

                                    </div>

                                    <div className="col-sm">
                                        <Field component={InputField} id='ValutazioneB1' label='Autovalutazione complessiva sez. B/1' />
                                    </div>

                                </div>

                                <div style={{ width: '100%' }} className="row">
                                    <img style={{ margin: '0 auto' }} className='b' src='/sezioneb2.png'></img>
                                </div>
                                <br />
                            </div>

                            <div style={{ width: '100%' }} className="row">
                                <img style={{ margin: '0 auto' }} className='b' src='/sezioneb2.png'></img>
                            </div>
                            <br />
                            <br />
                            <div className="row">

                                <FieldArray
                                    name="valutazione"
                                    render={arrayHelpers => {
                                        const autovalutazioneb2 = formik.values.autovalutazioneb2;
                                        function handleFormChange(index: React.Key, event: React.ChangeEvent<HTMLInputElement>): void {

                                            formik.values.autovalutazioneb2[index+''][event.target.name.split('.')[2]] = event.target.value;
                                            console.log('value ', event.target.value, event.target.name.split('.')[2])

                                        }

                                        return (
                                            <div style={{ width: '100%' }}>
                                                {autovalutazioneb2 && autovalutazioneb2.length > 0
                                                    ? autovalutazioneb2.map((autoval: any, index: React.Key) => (
                                                        <div key={index}>

                                                            <div style={{ border: 'solid', padding: 30 }} key={index}>
                                                                <div className="row"><label>Valutazione {parseInt('' + index) + 1}</label>

                                                                    <div className="col-sm">
                                                                        <div className="form-group">

                                                                            <label htmlFor={`autovalutazioneb2.${index}.denominazione`}>Denominazione Ente /soggetto Committente</label>
                                                                            <input type="text" className="form-control" name={`autovalutazioneb2.${index}.denominazione`} id={`autovalutazioneb2.${index}.denominazione`} onChange={event => handleFormChange(index, event)} />
                                                                            <small className="error">    <ErrorMessage name={`autovalutazioneb2.${index}.denominazione`} /> </small>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-sm">
                                                                        <div className="form-group">
                                                                            <label htmlFor={`autovalutazioneb2.${index}.durata`}>Durata in Mesi</label>
                                                                            <input type="number" className="form-control" name={`autovalutazioneb2.${index}.durata`} id={`autovalutazioneb2.${index}.durata`} onChange={event => handleFormChange(index, event)} />
                                                                            <small className="error">  <ErrorMessage name={`autovalutazioneb2.${index}.durata`} /> </small>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="row">

                                                                    <div className="col-sm">

                                                                        <label >Data inizio incarico</label>

                                                                        <input type="date" id={`autovalutazioneb2.${index}.datainizio`} name={`autovalutazioneb2.${index}.datainizio`} onChange={event => handleFormChange(index, event)} />

                                                                        <small className="error">  <ErrorMessage name={`autovalutazioneb2.${index}.datainizio`} /> </small>



                                                                    </div>


                                                                    <div className="col-sm">

                                                                        <label >Data Fine incarico</label>

                                                                        <input type="date" id={`autovalutazioneb2.${index}.datafine`} name={`autovalutazioneb2.${index}.datafine`} onChange={event => handleFormChange(index, event)} />

                                                                        <small className="error">  <ErrorMessage name={`autovalutazioneb2.${index}.datafine`} /> </small>


                                                                    </div>
                                                                </div>




                                                            </div>

                                                        </div>


                                                    ))
                                                    : null}
                                                {
                                                    <button
                                                        type="button"
                                                        onClick={() => aggiungiValutazione2(null, formik)} // insert an empty string at a position
                                                    >Aggiungi autovalutazione B2
                                                    </button>
                                                }
                                            </div>
                                        );
                                    }}
                                />

                                <div className="row"></div>
                                <div style={{ marginTop: 20, width: '100%' }} className="row">
                                    <br />

                                    <div className="col-sm">
                                        <div className="form-group">
                                            <label htmlFor='mesicomplessiviB2'>Durata in Mesi</label>
                                            <input type="number" className="form-control" name='mesicomplessiviB2' id='mesicomplessiviB2' onChange={
                                                event => {
                                                    formik.setFieldValue('mesicomplessiviB2', event.target.value)
                                                    verificamesib2(event.target.value, formik);

                                                }
                                            } />
                                            <small className="error">  <ErrorMessage name='ceckb2' /> </small>
                                        </div>
                                    </div>

                                    <div className="col-sm">
                                        <Field component={InputField} id='ValutazioneB2' label='Autovalutazione complessiva sez. B/2' />
                                    </div>



                                </div>

                            </div>

                            <div className="form-group"><div className="col-sm-12 text-center white bg-primary" style={{ color: 'white' }}>Allega</div></div>


                            <div className="form-check">
                                <input id="dichiara11" type="checkbox" onChange={event => formik.setFieldValue('dichiara11', event.target.checked)} />
                                <label htmlFor="dichiara11" >
                                    Il/La sottoscritto/a dichiara di essere consapevole di quanto prescritto dagli articoli 75 e 76 del
                                    D.P.R. 445/2000 sulla responsabilità penale cui può andare incontro in caso di dichiarazioni mendaci,
                                    nonché sulla decadenza dei benefici eventualmente conseguiti sulla base di dichiarazioni non veritiere, ai
                                    sensi e per gli effetti di cui agli articoli 46 e 47 del medesimo D.P.R. 445/2000.
                                    Il sottoscritto si impegna inoltre a fornire tutta la documentazione dimostrante quanto dichiarato
                                    su richiesta dell’amministrazione che ha prodotto il presente avviso.
                                    Si autorizza l’Ente al trattamento dei propri dati personali per le finalità inerenti lo svolgimento della
                                    presente procedura.

                                </label>
                                {formik.errors.dichiara11 && <small className="error">*Obbligatorio</small>}
                            </div>
                            <div className="form-upload" style={{ padding: 20 }}>
                                <label style={{ textOverflow: 'unset', whiteSpace: 'unset', lineHeight: 'inherit' }} htmlFor="documento" className="active">
                                    Fotocopia del documento d’identità in corso di validità del richiedente*
                                </label>
                                <input type="file" name="documento" id="documento" required className="is-invalid" data-focus-mouse="false" aria-invalid="true" aria-describedby="upload-error-1"
                                    onChange={e => formik.setFieldValue(`allegati.${0}.documento`, e.target.files[0])}
                                />
                                <small className="error"><ErrorMessage name={`allegati.${0}.documento`} /></small>

                            </div>

                            <div className="form-upload" style={{ padding: 20 }}>
                                <label style={{ textOverflow: 'unset', whiteSpace: 'unset', lineHeight: 'inherit' }} htmlFor="curriculum" className="active">
                                    Curriculum vitae in formato europeo redatto in forma di dichiarazione sostitutiva di atto notorio;
                                </label>
                                <input type="file" name="curriculum" id="curriculum" className="is-invalid" data-focus-mouse="false" aria-invalid="true" aria-describedby="upload-error-2"
                                    onChange={e => formik.setFieldValue(`allegati.${0}.curriculum`, e.target.files[0])}
                                />
                                <small className="error"><ErrorMessage name={`allegati.${0}.curriculum`} /></small>

                            </div>

                            <div className="form-check">
                                <input id="privacy" type="checkbox" onChange={event => formik.setFieldValue('privacy', event.target.checked)} />
                                <label htmlFor="privacy" > Acconsento al trattamento dei miei dati e dichiaro di aver preso visione della <a target={"_blank"} href="https://www.comune.rende.cs.it/privacy-policy/">Privacy Policy </a>
                                </label>
                                {formik.errors.privacy && <small className="error">*Obbligatorio</small>}
                            </div>
                            <div style={{ display: 'none' }} id='spinner' className="progress progress-indeterminate">
                                <span className="visually-hidden">In elaborazione...</span>
                                <div className="progress-bar" role="progressbar" />
                            </div>
                            <hr />
                            <div className="form-group">
                                <div className="btn-group col-sm-5 col-sm-offset-6 ">
                                    <button name="_anteprima" id="_anteprima" value="true" type="button" className="btn btn-primary btn-md pull-left" style={{ width: 150, display: 'none' }}

                                        onClick={() => {
                                            stampa_id('root');
                                            console.log(formik.errors);
                                        }}

                                    >Anteprima</button>
                                    {/**   <button name="_stampadomanda" id="_stampadomanda" value="true" type="button" className="btn btn-primary btn-md pull-left" style={{ width: 150 }}>Stampa domanda</button>
   */}  <button name="_conferma" id="_conferma" value="true" type="button" className="btn btn-primary btn-md pull-left" style={{ width: 150 }}
                                        onClick={() => {
                                            formik.validateForm().then(async res => {
                                                const { ob } = await res;

                                                let b = Object.keys(res).length;

                                                if (b > 0) {
                                                    Toast.fire({
                                                        title: 'ci sono ' + b + ' Errori nella compilazione',
                                                        icon: 'error'
                                                    });
                                                } else {
                                                    document.getElementById('spinner').style.display = 'inline';
                                                    //    document.getElementById('_conferma').style.display = 'none';

                                                }

                                                formik.submitForm();
                                                console.log(formik.errors);

                                            });
                                        }}>Invia</button></div>
                            </div>


                        </div>
                    </div>)
                }
            </Formik >

        </>
    )
}

export default Domanda;